import Vue from 'vue'
import Vuex from 'vuex'
import modules from './loader'
import createPersistedState from 'vuex-persistedstate'
import createCache from 'vuex-cache';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  plugins: [createPersistedState(), createCache()],
  modules,
  strict: debug
})
